var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('div',{staticClass:"loading-screen"},[_c('div',{staticClass:"spinner"}),_c('p',[_vm._v("Loading assessment...")])]):(_vm.quiz)?_c('LandingPage',{attrs:{"quiz":_vm.quiz}}):_c('div',{staticClass:"loading-screen"},[_c('p',[_vm._v("Assessment not found.")]),_c('router-link',{attrs:{"to":"/"}},[_vm._v("Back to Home")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }